/**
 * Locale-aware currency formatter for amounts stored in cents. Accepts any
 * ISO 4217 code (defaults to CAD, matching the platform default currency).
 * Use this for surfaces that know the record's currency (invoices, orders);
 * `formatPrice` remains for legacy `$`-prefixed displays.
 */
export function formatMoney(cents: number, currency?: string | null): string {
  const code = /^[A-Z]{3}$/i.test(currency ?? "")
    ? (currency as string).toUpperCase()
    : "CAD";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: code,
  }).format(cents / 100);
}
